import { COLORS, FlexView } from '@cuemath/comps';
import { Image, Text } from '@cuemath/web-comps';
import React from 'react';
import styled, { css } from 'styled-components';
import ArrowSeperatorIcon from 'img/top-bar/bread-crumbs-arrow.svg';
import PropTypes from 'prop-types';

const Wrapper = styled(FlexView)`
  border: 1px solid ${COLORS.GRAY_XLIGHT};
  border-radius: 21px;
`;
const Label = styled(Text)`
  padding: 0 12px;
`;
const Icon = styled(Image)`
  cursor: pointer;
`;
const ArrowLeft = styled(Icon)`
  transform: rotate(180deg);
`;
const IconWrapper = styled(FlexView)`
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      cursor: not-allowed;
      opacity: 0.4;
      pointer-events: none;
    `}
`;
const CalendarPaginationButton = ({ handlePagination, viewNextPage }) => {
  return (
    <Wrapper alignItems="center" flexDirection="row" gutter={12} gap={8}>
      <IconWrapper isDisabled={!viewNextPage} onClick={handlePagination}>
        <ArrowLeft
          height={24}
          width={24}
          url={ArrowSeperatorIcon}
          onClick={handlePagination}
        />
      </IconWrapper>
      <Label variant="body2">{viewNextPage ? `Prev days` : ` Next days`}</Label>
      <IconWrapper isDisabled={viewNextPage} onClick={handlePagination}>
        <Icon height={24} width={24} url={ArrowSeperatorIcon} />
      </IconWrapper>
    </Wrapper>
  );
};

CalendarPaginationButton.propTypes = {
  handlePagination: PropTypes.func,
  viewNextPage: PropTypes.bool,
};

export default CalendarPaginationButton;
